export default __webpack_public_path__ + "static/media/Glass-of-Learning-Logo-Main.ad39249c.jpg";